import React, { useEffect, useState } from 'react'
import styles from './textarea.module.css'

type TextareaProps={
  props:{
    title:string
    name:string
    placeholder:string
    max:number;
    height:number
    required:boolean
  }
  initialValue?:string
}


export default function Textarea({props,initialValue}:TextareaProps) {
  const [text,setText]=useState<string>(initialValue ? initialValue : "")

  useEffect(()=>{
    if(initialValue)
    setText(initialValue)
  },[initialValue])

  const handleChange=(e:React.ChangeEvent<HTMLTextAreaElement>)=>{
       setText(e.target.value)
  }

  return (
    <div className={styles["textarea-container"]}>
      <div className={styles.label}>{props.title}</div>
      <textarea name={props.name} value={text} maxLength={props.max} className={styles.textarea} 
                onChange={e=>handleChange(e)} style={{height:`${props.height}px`}} placeholder={props.placeholder}/>
    </div>
   
  )
}
